import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import TombstoneIcon from './resource/TombstoneIcon';

function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 3,
        px: 2,
      }}
    >
      <TombstoneIcon style={{ width: 80, height: 80, opacity: 0.5 }} />

      <Box>
        <Typography
          sx={{
            fontFamily: '"VT323", monospace',
            fontSize: 'clamp(4rem, 12vw, 8rem)',
            lineHeight: 1,
            color: 'text.disabled',
            letterSpacing: 4,
          }}
        >
          404
        </Typography>
        <Typography
          sx={{
            fontFamily: '"VT323", monospace',
            fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
            color: 'text.secondary',
            letterSpacing: 2,
            mt: 1,
          }}
        >
          THIS PAGE HAS EXPIRED
        </Typography>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
        Whatever you were looking for has run out of time — or it never existed.
        Either way, it's gone now.
      </Typography>

      <Button component={Link} to="/" variant="contained" size="large">
        Back to the land of the living
      </Button>
    </Box>
  );
}

export default NotFoundPage;
